import { orderBy } from 'lodash';

export default function($log, $sce) {
  'ngInject';

  const vm = this;

  vm.$onInit = activate;
  function getAlertTemplate(alert) {
    return {
      invite: '<firm-invite-alert ng-model="alertsCtrl.alert"></firm-invite-alert>',
      product: '<product-alert ng-model="alertsCtrl.alert"></product-alert>'
    }[alert.type];
  }

  function activate() {
    $log.debug('Alerts ctrl activated');

    const alert = orderBy(vm.ngModel, ['created_at'], ['asc'])[0];
    vm.alert = alert;

    const template = getAlertTemplate(alert);
    vm.template = $sce.trustAsHtml(template);
  }
}



// WEBPACK FOOTER //
// ./src/app/components/alertsCtrl/controller.js